import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SolarPowerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"solar_power"}/>
}
